import { MatDialogRef } from '@angular/material';
import { Component, OnInit } from '@angular/core';
import { ConfigService } from './../../../../../../service/config.service';

@Component({
    selector: 'app-consent-dialog',
    templateUrl: './consent-dialog.component.html',
    styleUrls: ['./consent-dialog.component.css']
})
export class ConsentDialogComponent implements OnInit {

    private readonly configService : ConfigService;
    private readonly matDialogRef: MatDialogRef<ConsentDialogComponent>;

    constructor(matDialogRef: MatDialogRef<ConsentDialogComponent>, configService: ConfigService) {
        this.matDialogRef = matDialogRef;
        this.configService = configService
    }

    ngOnInit(): void {
    }

    decline() {
        this.matDialogRef.close();
    }
    public getFileUrlByName(fileName): string{
        return this.configService.getPolicyFileUrlByName(fileName);
      }
}
